import { render, staticRenderFns } from "./companyDetails.vue?vue&type=template&id=c0e44cb6&scoped=true&"
import script from "./companyDetails.vue?vue&type=script&lang=js&"
export * from "./companyDetails.vue?vue&type=script&lang=js&"
import style0 from "./companyDetails.vue?vue&type=style&index=0&id=c0e44cb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e44cb6",
  null
  
)

export default component.exports